import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'EstimationItem' })((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        flex: '1 0 100%',
        justifyContent: 'space-between',
        borderBottom: '1px solid #0A0A0A',
        padding: '24px 0',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 12
        }
    },
    item: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px'
    },
    title: {
        width: 380,
        color: '#fff',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    },
    description: {
        flex: 1,
        color: '#8E8E8E',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    },
    credits: {
        width: 125,
        color: '#fff',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    }
}));
